export default __webpack_public_path__ + "static/media/img10ftD.0903f3a7.png";